/**
 * Utility functions for text formatting and manipulation
 */

/**
 * Get font size label from numeric size
 */
export const getFontSizeLabel = (size) => {
  if (size === 11) return "small";
  if (size === 14) return "medium";
  if (size === 18) return "big";
  return "medium"; // fallback default
};

/**
 * Place caret at the end of an element
 */
export const placeCaretAtEnd = (el) => {
  if (!el) return;
  const range = document.createRange();
  range.selectNodeContents(el);
  range.collapse(false);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
};

/**
 * Strip HTML tags from content
 */
export const stripHTML = (html) => {
  const tempEl = document.createElement("div");
  tempEl.innerHTML = html || "";
  return tempEl.innerText?.trim() || "";
};

/**
 * Handle number input with min/max limits
 */
export const handleNumberInputWithLimits = (
  field,
  value,
  min,
  max,
  transformFn
) => {
  let num = parseInt(value, 10);
  if (value === "" || isNaN(num)) {
    transformFn(field, min);
    return;
  }
  if (typeof min === "number" && num < min) num = min;
  if (typeof max === "number" && num > max) num = max;
  transformFn(field, num);
};

/**
 * Remove characters that are invalid for our numeric-only inputs.
 * Browsers allow "e/E/+/-" in number fields for scientific notation,
 * but our UI treats these as invalid.
 */
export const sanitizeNumericString = (value) => {
  if (typeof value !== "string") return value;
  return value.replace(/[eE+\-]/g, "");
};

/**
 * Check if a pressed key is invalid for our numeric-only inputs.
 */
export const isInvalidNumericKey = (key) =>
  key === "e" || key === "E" || key === "+" || key === "-";
